import React, { useEffect, useState } from "react";
import { useApolloClient } from "@apollo/react-hooks";
import { GET_STEP_DETAILS } from "./getStepDetail";
const MachineManufacturing = (props) => {
  const client = useApolloClient();
  const [stepDetails, setStepDetails] = useState([]);

  useEffect(() => {
    const GetClientSteps = () => {
      client
        .query({
          query: GET_STEP_DETAILS,
          variables: { step_id: props.StepID },
        })
        .then(({ data }) => {
          console.log("res", data.getFieldsByStepId);
          setStepDetails(data.getFieldsByStepId);
        })
        .catch((error) => {
          console.log("error", error);
          // toast.error(error.graphQLErrors[0].messasge.message)
        });
    };

    GetClientSteps();
    console.log("StepDetail MAchine", stepDetails);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepDetails]);
  return (
    <>
      <p className="input-heading">Machine</p>
      <div className="data-field">Machine</div>
      <p className="input-heading">Component MFG</p>

      <div className="data-field">Component MFG</div>
      <p className="input-heading">Mode Of Transportation</p>

      <div className="data-field">Mode Of Transportation</div>
      <p className="input-heading">Distance</p>
      <div className="data-field">Distance</div>
      <p className="input-heading">Carbon Content Transportation</p>
      <div className="data-field">Carbon Content Transportation</div>
      <p className="input-heading">Component Assembly</p>
      <div className="data-field">Component Assembly</div>
      <p className="input-heading">Bound Eergy/System</p>
      <div className="data-field">Bound Energy/System</div>
    </>
  );
};

export default MachineManufacturing;
